import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UtilsService } from 'app/back-office/shared/services/core/utils.service';

import { BasicHttpClientService } from './services/basic-http-client.service';
import { CoreService } from './services/core.service';
import { LoaderService } from './services/loader.service';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    OverlayModule,
    ReactiveFormsModule,
    RouterModule,
    FormsModule,
  ],
  exports: [
    HttpClientModule
  ],
  providers: [
    BasicHttpClientService,
    UtilsService,
    CoreService
  ],
  declarations: [
  ],
})
export class CoreModule {
  public static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        BasicHttpClientService,
        UtilsService,
        CoreService,
        LoaderService
      ]
    };
  }
}
